module.exports = __webpack_public_path__ + "img/circle.52d98fea.svg";